export const ar = {
  nav: {
    home: 'الرئيسية',
    services: 'خدماتنا',
    about: 'من نحن',
    contact: 'تواصل معنا',
    language: 'English'
  },
  hero: {
    title: 'مستقبل الزراعة في قطر',
    subtitle: 'حلول زراعية ذكية ومستدامة تدعم رؤية قطر 2030',
    cta1: 'اكتشف خدماتنا',
    cta2: 'تواصل معنا'
  },
  services: {
    label: 'خدماتنا',
    title: 'حلول زراعية متكاملة',
    subtitle: 'نقدم أحدث التقنيات لتحقيق الاستدامة والإنتاجية العالية',
    readMore: 'اقرأ المزيد',
    service1: {
      title: 'الزراعة الذكية',
      description: 'أنظمة مراقبة آلية مدعومة بالذكاء الاصطناعي لتحسين الإنتاجية وتقليل استهلاك الموارد'
    },
    service2: {
      title: 'الزراعة الرأسية وبدون تربة',
      description: 'أنظمة هيدروبونيك وشبه هيدروبونيك متطورة لإنتاج محاصيل عالية الجودة على مدار العام'
    },
    service3: {
      title: 'الزراعة التقليدية والموسمية',
      description: 'تحسين جودة التربة وتصدير المنتجات الوطنية بأعلى معايير الجودة العالمية'
    },
    service4: {
      title: 'الاستشارات والتصميم',
      description: 'بناء مزارع متكاملة للأفراد والشركات بحلول مخصصة تناسب احتياجاتك'
    }
  },
  about: {
    label: 'من نحن',
    title: 'نقود ثورة تكنولوجية في الزراعة القطرية',
    description: 'نحن في "إيف سمارت للخدمات الزراعية" (EVE Smart) نقود ثورة تكنولوجية في القطاع الزراعي بدولة قطر. نؤمن بأن المستقبل يكمن في دمج الابتكار بالاستدامة، لذا نتخصص في تقديم حلول الزراعة الذكية، وأنظمة الهيدروبونيك والزراعة الرأسية (Vertical Farming) التي تضمن أقصى إنتاجية بأقل استهلاك للموارد.',
    description2: 'رسالتنا هي دعم الأمن الغذائي الوطني وتمكين المستثمرين والمزارعين عبر أحدث تقنيات الجيل القادم، لنحول التحديات البيئية إلى فرص نمو مستدامة.',
    cta: 'تعرف على قصتنا',
    stat: 'مشروع زراعي ذكي',
    badge: 'شريك موثوق',
    since: 'منذ 2020'
  },
  values: {
    title: 'قيمنا الأساسية',
    value1: {
      title: 'الابتكار',
      description: 'نستخدم أحدث التقنيات والحلول المبتكرة لتطوير القطاع الزراعي'
    },
    value2: {
      title: 'الاستدامة',
      description: 'نلتزم بممارسات زراعية مستدامة تحافظ على البيئة للأجيال القادمة'
    },
    value3: {
      title: 'الجودة',
      description: 'نضمن أعلى معايير الجودة في جميع خدماتنا ومنتجاتنا الزراعية'
    }
  },
  cta: {
    question1: 'هل أنت مستعد',
    question2: 'لتحويل مزرعتك',
    question3: 'إلى مشروع ذكي؟',
    button: 'ابدأ الآن'
  },
  footer: {
    newsletter: {
      title: 'ابقَ على اطلاع',
      subtitle: 'اشترك في نشرتنا للحصول على آخر الابتكارات الزراعية',
      placeholder: 'بريدك الإلكتروني',
      button: 'اشترك'
    },
    quickLinks: {
      title: 'روابط سريعة',
      home: 'الرئيسية',
      services: 'خدماتنا',
      projects: 'المشاريع',
      contact: 'اتصل بنا'
    },
    contact: {
      title: 'تواصل معنا',
      email: 'evevsmart@gmail.com',
      locationTitle: 'موقعنا',
      location1: 'الدوحة، قطر',
      location2: 'منطقة  80  شارع  9999'
    },
    copyright: '© 2026 EVE Smart. جميع الحقوق محفوظة',
    privacy: 'سياسة الخصوصية',
    terms: 'الشروط والأحكام',
    poweredBy: 'مدعوم من Readdy'
  },
  privacy: {
    title: 'سياسة الخصوصية',
    description: 'سياسة الخصوصية لشركة إيف سمارت للخدمات الزراعية',
    section1: {
      title: 'مقدمة',
      content: 'في إيف سمارت للخدمات الزراعية، نحن ملتزمون بحماية خصوصيتك وأمان معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا وحمايتنا ومشاركتنا للمعلومات التي نحصل عليها من خلال موقعنا الإلكتروني وخدماتنا.'
    },
    section2: {
      title: 'المعلومات التي نجمعها',
      content: 'نقوم بجمع أنواع مختلفة من المعلومات لتقديم وتحسين خدماتنا لك:',
      item1: 'المعلومات الشخصية: الاسم، البريد الإلكتروني، رقم الهاتف، العنوان',
      item2: 'معلومات الشركة: اسم الشركة، نوع النشاط، الموقع',
      item3: 'معلومات تقنية: عنوان IP، نوع المتصفح، نظام التشغيل',
      item4: 'معلومات الاستخدام: كيفية تفاعلك مع موقعنا وخدماتنا'
    },
    section3: {
      title: 'كيفية استخدام المعلومات',
      content: 'نستخدم المعلومات التي نجمعها للأغراض التالية:',
      item1: 'تقديم وتحسين خدماتنا الزراعية الذكية',
      item2: 'التواصل معك بشأن استفساراتك وطلباتك',
      item3: 'إرسال تحديثات حول خدماتنا ومنتجاتنا الجديدة',
      item4: 'تحليل وتحسين أداء موقعنا الإلكتروني'
    },
    section4: {
      title: 'حماية المعلومات',
      content: 'نتخذ إجراءات أمنية صارمة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التغيير أو الإفصاح أو التدمير. نستخدم تقنيات التشفير والبروتوكولات الآمنة لضمان سلامة بياناتك.'
    },
    section5: {
      title: 'مشاركة المعلومات',
      content: 'نحن لا نبيع أو نؤجر أو نشارك معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية: عندما يكون ذلك ضرورياً لتقديم خدماتنا، عندما نحصل على موافقتك الصريحة، أو عندما يكون ذلك مطلوباً بموجب القانون.'
    },
    section6: {
      title: 'ملفات تعريف الارتباط (Cookies)',
      content: 'نستخدم ملفات تعريف الارتباط وتقنيات مشابهة لتحسين تجربتك على موقعنا. يمكنك التحكم في استخدام ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاص بك.'
    },
    section7: {
      title: 'حقوقك',
      content: 'لديك الحق في الوصول إلى معلوماتك الشخصية وتصحيحها أو حذفها. يمكنك أيضاً الاعتراض على معالجة بياناتك أو طلب تقييد استخدامها. للممارسة أي من هذه الحقوق، يرجى الاتصال بنا.'
    },
    contact: {
      title: 'اتصل بنا',
      content: 'إذا كان لديك أي أسئلة أو استفسارات حول سياسة الخصوصية هذه، يرجى التواصل معنا:',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف'
    },
    lastUpdated: 'آخر تحديث: يناير 2025'
  },
  terms: {
    title: 'الشروط والأحكام',
    lastUpdated: 'آخر تحديث',
    intro: 'مرحباً بك في إيف سمارت للخدمات الزراعية. باستخدامك لموقعنا الإلكتروني وخدماتنا، فإنك توافق على الالتزام بالشروط والأحكام التالية. يرجى قراءتها بعناية.',
    acceptance: {
      title: '1. قبول الشروط',
      content: 'باستخدام موقعنا الإلكتروني أو خدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام وجميع القوانين واللوائح المعمول بها. إذا كنت لا توافق على أي من هذه الشروط، يُمنع استخدام موقعنا أو خدماتنا.'
    },
    services: {
      title: '2. الخدمات المقدمة',
      content: 'تقدم إيف سمارت خدمات زراعية متخصصة تشمل الزراعة الذكية، الهيدروبونيك، والزراعة الرأسية. نحتفظ بالحق في تعديل أو إيقاف أي خدمة في أي وقت دون إشعار مسبق.'
    },
    userResponsibilities: {
      title: '3. مسؤوليات المستخدم',
      content: 'يوافق المستخدم على استخدام خدماتنا بطريقة قانونية ومسؤولة. يُحظر استخدام الموقع لأي أغراض غير قانونية أو ضارة. يجب على المستخدمين تقديم معلومات دقيقة وصحيحة عند التواصل معنا أو طلب خدماتنا.'
    },
    intellectualProperty: {
      title: '4. الملكية الفكرية',
      content: 'جميع المحتويات الموجودة على هذا الموقع، بما في ذلك النصوص والصور والشعارات والتصاميم، هي ملك لشركة إيف سمارت ومحمية بموجب قوانين حقوق النشر والملكية الفكرية. يُحظر نسخ أو توزيع أو استخدام أي محتوى دون إذن كتابي مسبق.'
    },
    liability: {
      title: '5. إخلاء المسؤولية',
      content: 'نسعى جاهدين لتقديم معلومات دقيقة وموثوقة، لكننا لا نضمن دقة أو اكتمال المحتوى على موقعنا. لا تتحمل إيف سمارت المسؤولية عن أي أضرار مباشرة أو غير مباشرة ناتجة عن استخدام موقعنا أو خدماتنا.'
    },
    modifications: {
      title: '6. التعديلات على الشروط',
      content: 'نحتفظ بالحق في تعديل هذه الشروط والأحكام في أي وقت. سيتم نشر أي تغييرات على هذه الصفحة مع تحديث تاريخ "آخر تحديث". استمرارك في استخدام الموقع بعد التعديلات يعني موافقتك على الشروط المحدثة.'
    },
    governingLaw: {
      title: '7. القانون الحاكم',
      content: 'تخضع هذه الشروط والأحكام لقوانين دولة قطر. أي نزاع ينشأ عن استخدام موقعنا أو خدماتنا سيتم حله وفقاً للقوانين القطرية.'
    },
    contact: {
      title: '8. الاتصال بنا',
      content: 'إذا كان لديك أي أسئلة أو استفسارات حول هذه الشروط والأحكام، يرجى التواصل معنا:'
    }
  }
};

export default ar;